import React from 'react';
import { LinkButton } from '../LinkButton';

class ResultText extends React.Component{

    constructor(props){
        super(props);
    }

    render(){
        if(this.props.result === 2){
            return(
            <article>
                <h2>Hups, joskus sattuu ja tapahtuu!</h2>
                <p>
                 Kun elää koko sydämellä, mahtuu matkan varrelle väistämättä myös kolhuja ja koettelemuksia. Pohjola Sairaalassa hoidamme sinut nopeasti takaisin kuntoon, koko sydämellä!
                </p>
                <LinkButton to="/quickform" class="btn-green" text="Lunasta pieni piristys" />
                <LinkButton to="/form" class="btn-white" text="Osallistu vain arvontaan" />
                <p className="smallText">
                 Jos et halua lunastaa pientä piristystä, voit osallistua myös vain leffalippupaketin arvontaan.
                </p>
            </article>
        );
        }else if(this.props.result === 1){
            return(
            <article>
                <h2>Ohops!</h2>
                <p>
                Kun elää koko sydämellä, voi kuoppa, kynnys tai liukas mutka joskus yllättää. Meillä pääset tapaturman sattuessa heti hoitoon. Voit tulla myös ilman ajanvarausta.
                </p>
                <a className="btn btn-green" onClick={() => { this.props.onRespin(); }} >Pyöräytä uudestaan</a>
                <LinkButton to="/form" class="btn-white" text="Osallistu arvontaan" />
                <p className="smallText">
                Jos et halua uutta pyöräytystä, voit osallistua myös suoraan leffalippupaketin arvontaan.
                </p>
            </article>
        );
        }else{
            return(
            <article>
                <h2>Kaikki kunnossa!</h2>
                <p>
                Mahtavaa, olet terve ja säästynyt tapaturmilta. Jos kaipaat vinkkejä hyvän terveyden ja kunnon tueksi, tutustu Pohjola Sairaalan asiantuntijoiden ohjeisiin pohjolasairaala.fi/pinnalla<br /><br />
                </p>
                <p>
                Osallistu leffalippupaketin arvontaan
                </p>
                <LinkButton to="/form" class="btn-green" text="Osallistu arvontaan" />

            </article>
        );
        }
    }
}

export class Result extends React.Component{
    render(){
        return(
            <div className="col-sm-4 content">
                <ResultText result={this.props.result} onRespin={this.props.onRespin} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/views/Result.js